import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-unrecognized-enrollment-key',
    templateUrl: './unrecognized-enrollment-key.component.html',
    styleUrls: ['./unrecognized-enrollment-key.component.scss'],
})
export class UnrecognizedEnrollmentKeyComponent {}
